module.exports = require("diffie-hellman");